/** @jsxImportSource @emotion/react */
import { css, useTheme } from '@emotion/react';
import Button from 'components/common/Button';

const Section6 = () => {
  const { mq } = useTheme();

  const section6Style = css`
    background: #87c77f;
    .container {
      max-width: 1535px;
      padding: 200px 40px;
      margin: 0 auto;
      p {
        font-size: 38px;
        font-weight: 600;
        line-height: 60px;
        color: #fff;
        span {
          font-size: inherit;
          font-weight: inherit;
          color: #277c05;
        }
      }
      button {
        margin-top: 70px;
      }
    }
    ${mq.mobile} {
      .container {
        padding: 83px 32px;
        p {
          font-size: 16px;
          font-weight: 600;
          line-height: 28px;
          span {
            font-size: 18px;
          }
        }
      }
    }
  `;
  return (
    <div css={section6Style}>
      <div className="container">
        <p>
          <span>판매 사업자도 몰을 만들 수 있어요!</span>
          <br />
          입점사, 셀러 회원도 몰을 만들 수 있습니다.
          <br /> 내 상품 뿐만아니라, 다른 셀러의 연관 상품을 함께 판매하여 더
          많은 고객과 매출을 늘려보세요.
          <br /> 이미 1만여개의 입점사가 몰파이와 함께 하고 있습니다.
        </p>
        <Button
          color="green"
          onClick={() =>
            window.open(
              'https://guide.mallpie.kr/seller-common/overview',
              '_blank',
            )
          }
        >
          입점사/셀러 서비스 안내
        </Button>
      </div>
    </div>
  );
};

export default Section6;
